// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigationMobile_navBar__H44dY {
    flex-direction: column;
    justify-content: center;
    height: 80px;
    padding-left: 20px;
    padding-right: 20px;
    background: #fff;
    box-shadow: 11.916px 23.833px 55.61px 0px rgba(0, 0, 0, 0.04);
    position: relative;
}

.navigationMobile_mobileNavLinks__d0YXC {
    position: absolute;
    background-color: #fcfcfc;
    width: 100%;
    left: 0px;
    top: 80px;
    z-index: 10 !important;
    box-shadow: 11.916px 23.833px 55.61px 0px rgba(0, 0, 0, 0.04);
}

.navigationMobile_navItems__tfVFf {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 40px;
    height: 100%;
    padding: 0;
    margin: 20px;
}

.navigationMobile_navItems__tfVFf li {
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.36px;
    color: #bfbfbf;
}

.navigationMobile_navItems__tfVFf li:hover {
    color: #5151f9;
}

.navigationMobile_toggleMenuButton__v1tl1 {
    height: 40px;
    width: 45px;
    border-radius: 5px;
    border: none;
    background-color: #fff;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 8px;
    padding-bottom: 9px;
}

.navigationMobile_toggleMenuButton__v1tl1 div {
    height: 3px;
    width: 100%;
    background-color: #686868;
}
`, "",{"version":3,"sources":["webpack://./src/_components/profile/navigationMobile/navigationMobile.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,SAAS;IACT,SAAS;IACT,sBAAsB;IACtB,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B","sourcesContent":[".navBar {\n    flex-direction: column;\n    justify-content: center;\n    height: 80px;\n    padding-left: 20px;\n    padding-right: 20px;\n    background: #fff;\n    box-shadow: 11.916px 23.833px 55.61px 0px rgba(0, 0, 0, 0.04);\n    position: relative;\n}\n\n.mobileNavLinks {\n    position: absolute;\n    background-color: #fcfcfc;\n    width: 100%;\n    left: 0px;\n    top: 80px;\n    z-index: 10 !important;\n    box-shadow: 11.916px 23.833px 55.61px 0px rgba(0, 0, 0, 0.04);\n}\n\n.navItems {\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    height: 100%;\n    padding: 0;\n    margin: 20px;\n}\n\n.navItems li {\n    cursor: pointer;\n    font-family: 'Poppins', sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: -0.36px;\n    color: #bfbfbf;\n}\n\n.navItems li:hover {\n    color: #5151f9;\n}\n\n.toggleMenuButton {\n    height: 40px;\n    width: 45px;\n    border-radius: 5px;\n    border: none;\n    background-color: #fff;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding-top: 8px;\n    padding-bottom: 9px;\n}\n\n.toggleMenuButton div {\n    height: 3px;\n    width: 100%;\n    background-color: #686868;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navBar": `navigationMobile_navBar__H44dY`,
	"mobileNavLinks": `navigationMobile_mobileNavLinks__d0YXC`,
	"navItems": `navigationMobile_navItems__tfVFf`,
	"toggleMenuButton": `navigationMobile_toggleMenuButton__v1tl1`
};
export default ___CSS_LOADER_EXPORT___;
